import React from 'react';
import { I18nextProvider } from 'react-i18next';
import ArenaOnBoardingController from '../../controllers/ArenaOnBoardingController';
import { FontUpgrade } from 'wix-style-react';

export function createArenaSplitPageApp(props) {
  const { i19n } = props;

  const arenaComponent = () => (
    <FontUpgrade active={true}>
      <ArenaOnBoardingController {...props} />
    </FontUpgrade>
  );

  const renderingComponent = arenaComponent();
  return <I18nextProvider i18n={i19n}>{renderingComponent}</I18nextProvider>;
}
